module.exports = __webpack_public_path__ + "img/warehouse-1.33d53243.jpg";